import { createContext, useContext } from "react";

// TraceLiveContext threads ONE authoritative "is this run live?" flag
// through StageRow -> LayerRow -> SubCallRow / BridgeStepRow /
// PerItemGroupRow. Rows render a rotating spinner for their in-flight
// state (sub-call: outcome "" + an attempt started; bridge step:
// duration_ms 0 + no error; stage: outcome "") ONLY when live === true.
//
// Why a single flag instead of per-row inference: on a TERMINAL run
// (persisted / failed), an unsealed stage keeps outcome === "" forever
// because it never paired with EndStage. Inferring "running" from that
// field made dead stages spin indefinitely. Liveness is a property of
// the RUN, not the row — so it lives at the source (useLiveTrace.source
// === "live") and flows down once.
//
// Default false → no spinners. Safe for any consumer (e.g. RunOutliers,
// compare-mode reference trees) that renders rows outside a live context.
export interface TraceLiveState {
  live: boolean;
}

export const TraceLiveContext = createContext<TraceLiveState>({
  live: false,
});

export function useTraceLive(): TraceLiveState {
  return useContext(TraceLiveContext);
}
